import axiosInstance from './axios.instance';

// Normalised to exactly one trailing slash. Every caller appends a path with no leading
// slash (routeConfig.js: `commonUrl = "api/v1/eklink"`) and the methods below concatenate
// it directly, so a base without one produced `...onrender.comapi/v1/...` and 404'd every
// call. Concatenating an absolute URL also bypasses the instance's `baseURL`, so axios
// never gets the chance to insert the separator itself.
const apiUrl = `${(process.env.REACT_APP_API_URL || '').replace(/\/+$/, '')}/`;

export class ApiService {
  async get(url) {
    const response =await axiosInstance.get(apiUrl + url);
    return response.data
  }

  async post(url, data) {
    const response = await axiosInstance.post(apiUrl + url, data);
    return response.data
  }

  async update(url, data) {
    const response = await axiosInstance.put(apiUrl + url, data);
    return response.data;
  }

  async delete(url) {
    const response = await axiosInstance.delete(apiUrl + url);
    return response.data;
  }

  async patch(url, data) {
    const response = await axiosInstance.patch(apiUrl + url, data);
    return response.data;
  }
}

export const apiService = new ApiService();
